import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
  CompareDocxRequest,
  LanguagesApiResponse,
  TranslateDocxB64Request
} from '../sign-link/second-version-esign/ai-features.interfaces';

const AI_BASE_URL = 'https://trident-backend-vmq73kpwua-uc.a.run.app';

@Injectable({
  providedIn: 'root'
})
export class AiFeaturesService {
  constructor(private http: HttpClient) {}

  getLanguages(): Observable<LanguagesApiResponse> {
    return this.http.get<LanguagesApiResponse>(
      `${AI_BASE_URL}/api/ai/languages`
    );
  }

  /**
   * Translates a document by sending its base64 content to the API.
   * Returns translated HTML in the response body (as JSON).
   */
  translateDocxB64(
    request: TranslateDocxB64Request
  ): Observable<HttpResponse<any>> {
    return this.http.post<{ data: string }>(
      `${AI_BASE_URL}/api/ai/translate/pdf-b64`,
      {
        data: request.document,
        mime_type: 'application/pdf',
        target_language: request.target_language
      },
      {
        observe: 'response',
        responseType: 'json'
      }
    );
  }

  /**
   * Summarizes a document by sending its base64 content to the API.
   * Returns summary content in the response body (as JSON).
   */
  summarizeDocument(documentBase64: string): Observable<HttpResponse<any>> {
    return this.http.post<any>(
      `${AI_BASE_URL}/api/ai/summarize-b64`,
      {
        data: documentBase64,
        mime_type: 'application/pdf',
        sentences: 5
      },
      {
        observe: 'response',
        responseType: 'json'
      }
    );
  }

  compareDocx(request: CompareDocxRequest): Observable<HttpResponse<Blob>> {
    const formData = new FormData();
    formData.append('file', request.file);
    formData.append('esign_id', request.esign_id);

    return this.http.post(`${AI_BASE_URL}/api/ai/compare/docx`, formData, {
      observe: 'response',
      responseType: 'blob'
    });
  }
}
